<template>
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1338_1255)">
      <path
        d="M7.76001 4.64717C7.782 4.65248 7.782 4.65248 7.76001 4.64717C7.3891 6.86204 5.21124 8.26898 3.03044 7.70845L3.03575 7.68645C3.34596 5.43368 5.57842 3.99335 7.76001 4.64717Z"
        fill="#FFE400"
      />
      <path
        d="M0.349107 2.80279C0.945402 0.95647 2.84576 -0.168227 4.76179 0.235393C4.22924 2.15527 2.29323 3.28301 0.349107 2.80279Z"
        fill="#FFE400"
      />
      <path
        d="M7.83429 4.33921C5.45473 3.63766 3.06152 5.21382 2.73619 7.62587C0.892121 6.97193 -0.186325 5.02454 0.274939 3.11076C2.39505 3.63339 4.49484 2.40547 5.08347 0.301268C6.83041 0.827059 7.99447 2.51579 7.83429 4.33921Z"
        fill="#5EB24A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1338_1255">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
